export default function init_menu(IconsView, iconsViewCache) {

    IconsView.prototype.createMenu = function (datas, icon) {
        const myself = this;
        let menu = $('.menu--context');
        if (!menu.length) {
            $('body').append('<div class="menu menu--context"><div class="menu__content"><div class="menu__inner"></div></div></div>');
            menu = $('.menu--context');
            $('body').on('contextmenu', () => {
                if ($('.menu--context').hasClass('menu--open')) {
                    myself.element.find('.iv__item--context').removeClass('iv__item--context');
                    $('.menu--context').removeClass('menu--open');
                    return false;
                }

                return true;
            });
            $('body').click(() => {
                $('.menu--context').removeClass('menu--open');
                myself.element.find('.iv__item--context').removeClass('iv__item--context');
            });
        }
        menu.addClass('menu--open');
        myself.element.find('.iv__item--context').removeClass('iv__item--context');
        if (icon) icon.addClass('iv__item--context');

        menu.find('.menu__inner').html('');
        const menuList = $('<ul class="menu__list"></ul>');
        menu.find('.menu__inner').append(menuList);

        myself.createMenuItems(datas, menuList, icon);

        imgToSvg($('.menu--context'));

        // Position with boundary detection
        let top = mouseY;
        let left = mouseX;

        const menuWidth = menu.outerWidth();
        const menuHeight = menu.outerHeight();
        const windowWidth = $(window).width();
        const windowHeight = $(window).height();
        const scrollLeft = $(window).scrollLeft();
        const scrollTop = $(window).scrollTop();

        // Horizontal boundary
        if (left + menuWidth > windowWidth + scrollLeft) {
            left = mouseX - menuWidth;
        }

        // Vertical boundary
        if (top + menuHeight > windowHeight + scrollTop) {
            top = mouseY - menuHeight;
        }

        // Safety check
        if (left < scrollLeft) left = scrollLeft;
        if (top < scrollTop) top = scrollTop;

        menu.css('top', top).css('left', left);
    }


    IconsView.prototype.createMenuItems = function (datas, menuList, icon) {
        const myself = this;
        const menu = $('.menu--context');
        $.each(datas, (index, data) => {
            var item = '';
            if (data == '-') {
                var item = $(`
                    <li class="menu__item menu__item--separator"><span class="menu__line"></span></li>
                    `);
            } else {
                var item = $(`
                    <li class="menu__item">
                        <div class="menu__link"><span class="menu__icon">` + myself.renderIconImage(16, data.icon, data, 'img') + '</span><span class="menu__label">' + data.name + `</span></div>
                    </li>
                    `);
            }
            menuList.append(item);
            if (data != '-') {
                item.click((event) => {
                    menu.removeClass('menu--open');
                    myself.element.find('.iv__item--context').removeClass('iv__item--context');
                    // console.log(icon);
                    if (data.callback) data.callback(icon);
                    event.stopPropagation();
                });
                if (data.items) {
                    item.addClass('menu__item--parent');
                    const subList = $('<ul class="menu__list"></ul>');
                    item.append(subList);
                    myself.createMenuItems(data.items, subList, icon);

                    item.on('mouseenter', function () {
                        const sub = $(this).find('> .menu__list');
                        const subWidth = sub.outerWidth();
                        const subHeight = sub.outerHeight();
                        const offset = $(this).offset();
                        const windowWidth = $(window).width();
                        const windowHeight = $(window).height();
                        const scrollLeft = $(window).scrollLeft();
                        const scrollTop = $(window).scrollTop();

                        // Horizontal flip
                        if (offset.left + $(this).outerWidth() + subWidth > windowWidth + scrollLeft) {
                            sub.css('left', 'auto').css('right', '100%');
                        } else {
                            sub.css('left', '100%').css('right', 'auto');
                        }

                        // Vertical flip
                        if (offset.top + subHeight > windowHeight + scrollTop) {
                            sub.css('top', 'auto').css('bottom', '0');
                            // Safety if sub-menu is taller than window
                            const newOffsetTop = offset.top + $(this).outerHeight() - subHeight;
                            if (newOffsetTop < scrollTop) {
                                sub.css('top', (scrollTop - offset.top) + 'px').css('bottom', 'auto');
                            }
                        } else {
                            sub.css('top', '0').css('bottom', 'auto');
                        }
                    });
                }
            }
        })
    }
}
